import Header from '@components/Header';
import colors from '@constants/colors';
import CloseLineIcon from '@icons/CloseLineIcon';
import { useFlow } from '@router/stackflow';

function ReceiptHeader() {
  const { pop } = useFlow();
  return (
        <Header title='전자영수증'
                noShadow
                noBackIcon
                trailing={<CloseLineIcon size={24}
                                     color={colors.gray6}
                                     onClick={pop} />} />
  );
}

export default ReceiptHeader;
